export const backgroundImages = [
  '-images/01-01',
  '-images/02-02',
  '-images/04-01',
  '-images/05-02',
  '-images/06-02',
  '-images/08-01',
  '-images/08-05',
  '-images/09-04',
  '-images/10-01',
  '-images/11',
  '-images/01-02',
  '-images/03-01',
  '-images/04-02',
  '-images/05-03',
  '-images/07-01',
  '-images/08-02',
  '-images/09-01',
  '-images/09-05',
  '-images/10-02',
  '-images/12',
  '-images/01-03',
  '-images/03-02',
  '-images/04-03',
  '-images/05-04',
  '-images/07-02',
  '-images/08-03',
  '-images/09-02',
  '-images/09-06',
  '-images/10-03',
  '-images/13-01',
  '-images/02-01',
  '-images/03-03',
  '-images/05-01',
  '-images/06-01',
  '-images/07-03',
  '-images/08-04',
  '-images/09-03',
  '-images/09-08',
  '-images/10-04',
  '-images/13-02'
]
